module.exports = __webpack_public_path__ + "img/file1.86b2e7c0.png";